<template>
  <div id="character" class="character">
    <div class="character-background">
      <v-img class="character-title" src="../assets/img/character-title.png" />
      <div class="character-img">
        <v-img class="character-img-1" src="../assets/img/item-Cosmetics.png" />
        <v-img class="character-img-2" src="../assets/img/item-Earring.png" />
        <v-img class="character-img-3" src="../assets/img/character-img1.png" />
      </div>
      <div class="character-text">
        <p>名前：あやな</p>
        <div class="border" />
        <p>身長：158cm</p>
        <div class="border" />
        <p>好きなもの：甘いもの</p>
        <div class="border" />
        <p>嫌いなもの：しいたけ</p>
        <div class="border" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CharacterView',
};
</script>

<style lang="scss" scoped>
.character {
  position: relative;
  background: url(../assets/img/background.png) repeat-y;
  background-size: 200% auto;
  background-attachment: fixed;
  font: 5.6vw 'ヒラギノ丸ゴ Pro W4', 'ヒラギノ丸ゴ Pro', 'Hiragino Maru Gothic Pro';
  text-shadow: 0px 0px 1px white;
  color: #919191;
  line-height: 1.7em;
  @media screen and (min-width: 960px) {
    background-size: 100% auto;
    font-size: 2.5vw;
    line-height: 2em;
  }
  &-background {
    padding: 10% 0 10%;
    background-color: rgba(255, 255, 255, 0.75);
  }
  &-title {
    margin: 7% auto 18%;
    width: 90%;
    @media screen and (min-width: 960px) {
      width: 45%;
      margin: 5% auto 8%;
    }
  }
  &-img {
    @media screen and (min-width: 960px) {
      width: 70%;
      margin: 0 auto;
    }
    &-1 {
      position: absolute;
      top: 68%;
      right: 60%;
      width: 50%;
      transform: rotateZ(-25deg);
      opacity: 0.3;
      @media screen and (min-width: 960px) {
        width: 40%;
        top: 47%;
        right: 51%;
      }
    }
    &-2 {
      position: absolute;
      top: 63%;
      right: 37%;
      width: 35%;
      transform: rotateZ(30deg);
      opacity: 0.2;
      @media screen and (min-width: 960px) {
        width: 15%;
        top: 34%;
        right: 37%;
      }
    }
    &-3 {
      top: 32%;
      width: 50%;
      left: 50%;
      @media screen and (min-width: 960px) {
        left: 65%;
        width: 37%;
      }
    }
  }
  &-text {
    position: absolute;
    width: 70%;
    top: 40%;
    right: 27%;
    @media screen and (min-width: 960px) {
      width: 33%;
      top: 39%;
      left: 27%;
    }
    p {
      text-shadow: 1.5px 1.5px 1.5px #fff, -1.5px -1.5px 1.5px #fff, -1.5px 1.5px 1.5px #fff, 1.5px -1.5px 1.5px #fff,
        1.5px 0px 1.5px #fff, -1.5px -0px 1.5px #fff, 0px 1.5px 1.5px #fff, 0px -1.5px 1.5px #fff;
      @media screen and (min-width: 960px) {
        text-shadow: 2.5px 2.5px 2.5px #fff, -2.5px -2.5px 2.5px #fff, -2.5px 2.5px 2.5px #fff, 2.5px -2.5px 2.5px #fff,
          2.5px 0px 2.5px #fff, -2.5px -0px 2.5px #fff, 0px 2.5px 2.5px #fff, 0px -2.5px 2.5px #fff;
      }
    }
    p:nth-of-type(3),
    p:nth-of-type(4) {
      letter-spacing: -1.5px;
      @media screen and (min-width: 960px) {
        letter-spacing: 0px;
      }
    }
    .border {
      position: relative;
      border-radius: 10px;
      height: 1px;
      width: 75%;
      @media screen and (min-width: 960px) {
        border-radius: 100px;
        height: 3px;
        width: 85%;
      }
    }
    .border::before {
      content: '';
      background-image: linear-gradient(to right, #fff, #fff 24px, transparent 24px, transparent 44px);
      background-size: 44px 5.5px;
      background-repeat: repeat-x;
      position: absolute;
      top: -13px;
      bottom: 0;
      left: -5px;
      right: 0;
      @media screen and (min-width: 960px) {
        background-image: linear-gradient(to right, #fff, #fff 52px, transparent 52px, transparent 95px);
        background-size: 95px 11px;
      }
    }
    .border::after {
      content: '';
      background-image: linear-gradient(to right, #ababab, #ababab 22px, transparent 22px, transparent 44px);
      background-size: 44px 3.5px;
      background-repeat: repeat-x;
      position: absolute;
      top: -10px;
      bottom: 0;
      left: -3px;
      right: 0;
      @media screen and (min-width: 960px) {
        background-image: linear-gradient(to right, #ababab, #ababab 48px, transparent 48px, transparent 95px);
        background-size: 95px 4px;
      }
    }
  }
}
</style>
